import { API_CALL_STATUS, FIELD_STATUS, FORM_STATUS } from '../status';

import {
    FIRST_NAME_SET_VALUE,
    FIRST_NAME_SET_VALID,
    LAST_NAME_SET_VALUE,
    LAST_NAME_SET_VALID,
    ID_NUMBER_SET_VALUE,
    ID_NUMBER_SET_VALID,
    RELATIONSHIP_SET_VALUE,
    RELATIONSHIP_SET_VALID,
    LOCATION_SET_VALUE,
    LOCATION_SET_VALID,
    PHONE_NUMBER_SET_VALUE,
    PHONE_NUMBER_SET_VALID,
    EMAIL_SET_VALUE,
    EMAIL_SET_VALID,
    PERCENTAGE_SPLIT_SET_VALUE,
    PERCENTAGE_SPLIT_SET_VALID,
    REINITIALIZE,
    REINITIALIZE_SINGLE,
    ADD_BENEFICIARY,
    REMOVE_BENEFICIARY,
    SELECTED_FORM_INDEX_SET_VALUE,
    FORM_VALID_PERSONAL_PENSION_PLAN_BENEFICIARIES_FORM,
    FORM_INVALID_PERSONAL_PENSION_PLAN_BENEFICIARIES_FORM,
    API_INITIAL_TRANSITION_BENEFICIARIES_FORM,
    API_PENDING_TRANSITION_BENEFICIARIES_FORM,
    API_SUCCESS_TRANSITION_BENEFICIARIES_FORM,
    API_FAILURE_TRANSITION_BENEFICIARIES_FORM,
    PERSONAL_DATA_PROCESSING_CONSENT_SET_VALUE,
    PERSONAL_DATA_TERMS_SET_VALUE,
    PERSONAL_DATA_TERMS_DRAWER_SET_VISIBLE,
} from '../../actions/personalPensionPlan/beneficiaries';

export const initBeneficiaries = {
    formStatus: [],
    apiCallStatus: null,
    form: [],
    selectedFormIndex: null,
    personalDataTerms: '',
    personalDataProcessingConsent: false,
    displayDataProcessingConsentDrawer: false,
};

export default (state = initBeneficiaries, action) => {
    const mapError = (error) => (error ? FIELD_STATUS.ERROR : FIELD_STATUS.VALID);
    const updateFormField = (fieldId, update, index) => ({
        ...state,
        form: state.form.map((item, idx) => {
            if (idx === index) {
                return {
                    ...item,
                    [fieldId]: update(item[fieldId]),
                };
            } else {
                return item;
            }
        }),
    });

    switch (action.type) {
        case PERSONAL_DATA_TERMS_DRAWER_SET_VISIBLE:
            return {
                ...state,
                displayDataProcessingConsentDrawer: action.value,
            };
        case PERSONAL_DATA_PROCESSING_CONSENT_SET_VALUE:
            return {
                ...state,
                personalDataProcessingConsent: action.value,
            };
        case PERSONAL_DATA_TERMS_SET_VALUE:
            return {
                ...state,
                personalDataTerms: action.value,
            };
        //    API Calls
        case API_INITIAL_TRANSITION_BENEFICIARIES_FORM:
            return { ...state, apiCallStatus: null };

        case API_PENDING_TRANSITION_BENEFICIARIES_FORM:
            return { ...state, apiCallStatus: API_CALL_STATUS.PENDING };

        case API_SUCCESS_TRANSITION_BENEFICIARIES_FORM:
            return { ...state, apiCallStatus: API_CALL_STATUS.SUCCESS };

        case API_FAILURE_TRANSITION_BENEFICIARIES_FORM:
            return { ...state, apiCallStatus: API_CALL_STATUS.FAILURE };

        case SELECTED_FORM_INDEX_SET_VALUE:
            return { ...state, selectedFormIndex: action.value };

        case REINITIALIZE:
            return initBeneficiaries;

        case REINITIALIZE_SINGLE:
            const indexToEdit = action.index;

            if (indexToEdit >= 0 && indexToEdit < state.form.length) {
                const updatedForm = [...state.form];
                updatedForm[indexToEdit] = {
                    firstName: { value: null, error: null, status: null },
                    lastName: { value: null, error: null, status: null },
                    idNumber: { value: null, error: null, status: null },
                    relationship: { value: null, error: null, status: null },
                    location: { value: null, error: null, status: null },
                    phoneNumber: { value: null, error: null, status: null },
                    email: { value: null, error: null, status: null },
                    percentageSplit: { value: null, error: null, status: null },
                };

                const updatedFormStatus = [...state.formStatus];

                updatedFormStatus[indexToEdit] = FORM_STATUS.INVALID;

                return {
                    ...state,
                    formStatus: updatedFormStatus,
                    form: updatedForm,
                };
            }

            return state;

        case ADD_BENEFICIARY:
            return {
                ...state,
                formStatus: [...state.formStatus, FORM_STATUS.INVALID],
                form: [
                    ...state.form,
                    {
                        firstName: { value: null, error: null, status: null },
                        lastName: { value: null, error: null, status: null },
                        idNumber: { value: null, error: null, status: null },
                        relationship: { value: null, error: null, status: null },
                        location: { value: null, error: null, status: null },
                        phoneNumber: { value: null, error: null, status: null },
                        email: { value: null, error: null, status: null },
                        percentageSplit: { value: null, error: null, status: null },
                    },
                ],
            };

        case REMOVE_BENEFICIARY:
            const indexToRemove = action.index;

            if (indexToRemove >= 0 && indexToRemove < state.form.length) {
                const updatedForm = state.form.filter((_, idx) => idx !== indexToRemove);

                const updatedFormStatus = state.formStatus.filter((_, idx) => idx !== indexToRemove);

                return {
                    ...state,
                    formStatus: updatedFormStatus,
                    form: updatedForm,
                };
            }

            return state;

        case FORM_VALID_PERSONAL_PENSION_PLAN_BENEFICIARIES_FORM:
            const validIndex = action.index;

            if (validIndex >= 0 && validIndex < state.formStatus.length) {
                const updatedFormStatus = [...state.formStatus];
                updatedFormStatus[validIndex] = FORM_STATUS.VALID;

                return {
                    ...state,
                    formStatus: updatedFormStatus,
                };
            }

            return state;

        case FORM_INVALID_PERSONAL_PENSION_PLAN_BENEFICIARIES_FORM:
            const index = action.index;

            if (index >= 0 && index < state.formStatus.length) {
                const updatedFormStatus = [...state.formStatus];
                updatedFormStatus[index] = FORM_STATUS.INVALID;

                return {
                    ...state,
                    formStatus: updatedFormStatus,
                };
            }

            return state;

        case FIRST_NAME_SET_VALUE:
            return updateFormField(
                'firstName',
                (field) => ({
                    ...field,
                    value: action.value,
                }),
                action.index
            );
        case FIRST_NAME_SET_VALID:
            return updateFormField(
                'firstName',
                (field) => ({
                    ...field,
                    error: action.error,
                    status: mapError(action.error),
                }),
                action.index
            );

        case LAST_NAME_SET_VALUE:
            return updateFormField(
                'lastName',
                (field) => ({
                    ...field,
                    value: action.value,
                }),
                action.index
            );
        case LAST_NAME_SET_VALID:
            return updateFormField(
                'lastName',
                (field) => ({
                    ...field,
                    error: action.error,
                    status: mapError(action.error),
                }),
                action.index
            );

        case ID_NUMBER_SET_VALUE:
            return updateFormField(
                'idNumber',
                (field) => ({
                    ...field,
                    value: action.value,
                }),
                action.index
            );
        case ID_NUMBER_SET_VALID:
            return updateFormField(
                'idNumber',
                (field) => ({
                    ...field,
                    error: action.error,
                    status: mapError(action.error),
                }),
                action.index
            );

        case RELATIONSHIP_SET_VALUE:
            return updateFormField(
                'relationship',
                (field) => ({
                    ...field,
                    value: action.value,
                }),
                action.index
            );
        case RELATIONSHIP_SET_VALID:
            return updateFormField(
                'relationship',
                (field) => ({
                    ...field,
                    error: action.error,
                    status: mapError(action.error),
                }),
                action.index
            );

        case LOCATION_SET_VALUE:
            return updateFormField(
                'location',
                (field) => ({
                    ...field,
                    value: action.value,
                }),
                action.index
            );
        case LOCATION_SET_VALID:
            return updateFormField(
                'location',
                (field) => ({
                    ...field,
                    error: action.error,
                    status: mapError(action.error),
                }),
                action.index
            );

        case PHONE_NUMBER_SET_VALUE:
            return updateFormField(
                'phoneNumber',
                (field) => ({
                    ...field,
                    value: action.value,
                }),
                action.index
            );
        case PHONE_NUMBER_SET_VALID:
            return updateFormField(
                'phoneNumber',
                (field) => ({
                    ...field,
                    error: action.error,
                    status: mapError(action.error),
                }),
                action.index
            );

        case EMAIL_SET_VALUE:
            return updateFormField(
                'email',
                (field) => ({
                    ...field,
                    value: action.value,
                }),
                action.index
            );
        case EMAIL_SET_VALID:
            return updateFormField(
                'email',
                (field) => ({
                    ...field,
                    error: action.error,
                    status: mapError(action.error),
                }),
                action.index
            );

        case PERCENTAGE_SPLIT_SET_VALUE:
            return updateFormField(
                'percentageSplit',
                (field) => ({
                    ...field,
                    value: action.value,
                }),
                action.index
            );
        case PERCENTAGE_SPLIT_SET_VALID:
            return updateFormField(
                'percentageSplit',
                (field) => ({
                    ...field,
                    error: action.error,
                    status: mapError(action.error),
                }),
                action.index
            );

        default:
            return state;
    }
};
